// Default page size for all list/table pages.
// PRD 15 §2.2 fixes the admin list at 20/page; same default applies elsewhere
// until a PRD calls out a different value.
export const DEFAULT_PAGE_SIZE = 20;

/**
 * Options for the "N개씩 보기" selector, on the pages that HAVE one.
 *
 * Canonical: PRD 21 §2.3 (공통 시스템정의) — "기본 표시 건수: 20개 고정 (일부 페이지는
 * 20/50/100 옵션 제공)". Per requirement precedence the common definition outranks the
 * feature PRDs, so 20/50/100 is the set even though PRD 02 §2.2 No.6 spells out
 * (20/30/50) and the prototypes ship 20/30/50 — those are documentation drift to fix.
 * Decided 2026-08-04.
 *
 * SHCT-715 — 건강백과's selector shipped with one option and a no-op onChange, so
 * "목록 표시 개수 선택" (PRD 10 §2.2 No.8) could not select anything.
 *
 * NOT every list gets a selector. PRD 21 §2.3 says 20 is fixed and only SOME pages
 * offer options, and four feature PRDs mark the control `20개씩 보기 (고정)` with
 * editable = N — 07 관리지침 · 13 공지사항 · 15 어드민관리 · 18 로그조회. Those keep the
 * single locked option; do not wire them to this constant.
 *
 * Pages that DO use it: 02 환자관리 · 03 의료진관리 · 10 건강백과 · 11 상담매뉴얼 ·
 * 12 환자문의관리. `DEFAULT_PAGE_SIZE` stays the first option, so each page's initial
 * render is unchanged.
 */
export const PAGE_SIZE_OPTIONS: readonly number[] = [20, 50, 100] as const;
